import {
  StringSetting,
  useUserSettingWithDefault,
  UseUserSettingWithDefaultReturnType,
} from "shared-ts-utils-user-settings";
import { useAppTheme } from "./AppThemeProvider";
import { ThemeName } from "./ThemeName";

export const useThemeUserSetting = () => {
  const { themeName } = useAppTheme();
  return useUserSettingWithDefault("theme", StringSetting, themeName, {
    storeLocally: true,
    storeCopyToAppLocally: true,
  }) as UseUserSettingWithDefaultReturnType<ThemeName>;
};
